import { Box, Flex, Input } from '@chakra-ui/react';
import { useState } from 'react';
import { HiSearch } from 'react-icons/hi';
import { logSearchTerm } from '../../firebase/analytics';
import { usePageDataCache } from '../../hooks/usePageDataCache';

const LogPrefix = 'SearchInput';

export interface PastSixListItemProps {
    view: string;
    onSearchClear: () => void;
    onTriggerSearch: (val: string) => void;
}

export const SearchInput: React.FC<PastSixListItemProps> = ({
    view,
    onSearchClear,
    onTriggerSearch,
}) => {
    const [searchText, setSearchText] = usePageDataCache<string>('searchText', '');
    const [logSearchTimeout, setLogSearchTimeout] = useState<NodeJS.Timeout | undefined>(undefined);

    const updateSearch = (event: any) => {
        const logPrefix = `[${LogPrefix}.updateSearch]`;
        const text = event.target.value.toLowerCase();
        setSearchText(text);
        console.log(`${logPrefix} set search text to: ${text}`);

        if (text.length === 0) {
            onSearchClear();
        }
    };

    const triggerSearch = () => {
        if (searchText.length >= 3) {
            onTriggerSearch(searchText);
        }

        logSearch(searchText);
    };

    const logSearch = (text: string) => {
        if (text.length <= 3) {
            return;
        }

        if (!!logSearchTimeout) {
            clearTimeout(logSearchTimeout);
        }
        setLogSearchTimeout(setTimeout(() => logSearchTerm(text), 1000));
    };

    return (
        <Flex className={`search-bar${view === 'browser' ? '-browser' : ''}`}>
            <Flex className={'search-input'} width={'100%'} maxWidth={'100%'}>
                <Input
                    variant={'unstyled'}
                    value={searchText}
                    onChange={updateSearch}
                    enterKeyHint={'search'}
                    onKeyDown={(e) => e.key === 'Enter' && triggerSearch()}
                />
                <Box className={'search-icon'}>
                    <HiSearch className={'search-svg'} onClick={triggerSearch} />
                </Box>
            </Flex>
        </Flex>
    );
};
